import { Checkbox, Paper, Select } from '../../../../common/Form'
import { MatroxE4ApplianceSettings, MatroxEncoderGenlockResolution } from 'common/api/v1/types'

interface Props {
  settings: MatroxE4ApplianceSettings
}

const resolutionOptions = Object.values(MatroxEncoderGenlockResolution)

const MatroxE4ApplianceSettingsComp = ({ settings }: Props) => {
  return (
    <Paper title="Matrox Settings">
      <Paper title="Genlock">
        <Checkbox label={'Enabled'} name={`settings.genlock.isEnabled`} />
        <Select
          label="Resolution"
          name={`settings.genlock.resolution`}
          required
          disabled={!settings.genlock.isEnabled}
          options={resolutionOptions}
        />
      </Paper>
    </Paper>
  )
}

export default MatroxE4ApplianceSettingsComp
